<template>
  <div class="employee-tab-inner leave-align-mobile">
    <div class="row">
      <div class="col-md-12">
        <div class="clearfix leave-log mb-3">
          <div class="py-3 employee-investment-wrapper">
            <div class="px-3">
              <div class="row no-gutters mb-3">
                <div class="col-md-12 leave-log-wrapper px-4">
                  <div class="clearfix rounded pb-5 mx-auto">
                    <div class="row mb-3">
                      <div class="col-12 col-md-6 company-form-box-title pb-3">
                        Leave Log
                      </div>
                      <div
                        class="col-12 col-md-6 d-flex justify-content-end align-items-center"
                      >
                        <div class="mr-3">
                          <b-form-select
                            @change="getLeaves"
                            v-model="leave_year"
                          >
                            <b-form-select-option
                              v-for="(year, n) in years"
                              :key="n"
                              :value="year"
                              >{{ year }}</b-form-select-option
                            >
                          </b-form-select>
                        </div>
                        <b-button
                          @click="$bvModal.show('bv-modal-add-leave-profile')"
                          class="apply-leave-roster"
                        >
                          <img
                            src="/images/la/Apply for leave - Default.svg"
                            alt=""
                          />
                          Apply For Leave
                        </b-button>
                      </div>
                    </div>

                    <div class="row justify-content-center no-margin">
                      <div class="col-sm-12 px-0">
                        <b-overlay :show="showoverlay_list" rounded="sm">
                          <div
                            class="employee-table-wrapper"
                          >
                            <table
                              class="employee-list-table employee-list-table-leave dataTable table-overflow ess-custom-table"
                            >
                              <thead>
                                <tr class="table-head">
                                  <td
                                    v-for="column in columns"
                                    :key="column.name"
                                    @click="sortBy(column.name)"
                                    :class="
                                      sortKey === column.name
                                        ? sortOrders[column.name] > 0
                                          ? 'sorting_asc'
                                          : 'sorting_desc'
                                        : 'sorting'
                                    "
                                    class="cursor-pointer"
                                  >
                                    <template
                                      v-if="
                                        column.name != 'to' &&
                                        column.name != 'from'
                                      "
                                    >
                                      <label class="custom-label"
                                        ><span>{{ column.label }}</span></label
                                      >
                                    </template>
                                    <template v-else>
                                      <label class="custom-label"
                                        ><span> {{ column.label }}</span>
                                        <div class="table-header">
                                          <div class="table sub-header">
                                            (YYYY-MM-DD)
                                          </div>
                                        </div>
                                      </label>
                                    </template>
                                  </td>
                                  <td class="text-right" v-if="ce">
                                    <label class="custom-label">Action</label>
                                  </td>
                                </tr>
                              </thead>

                              <tbody>
                                <template v-if="paginatedData.length > 0">
                                  <tr
                                    class="table-row hover-bg"
                                    v-for="(leave, n) in paginatedData"
                                    :key="n"
                                  >
                                    <td
                                      class=""
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      <b-icon :icon="leave.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                                      {{ leave.leave_type }}
                                    </td>
                                    <td
                                      class=""
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      {{ leave.from }}
                                    </td>
                                    <td
                                      class=""
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      {{ leave.to }}
                                    </td>
                                    <td
                                      class=""
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      <template v-if="leave.leave_day == 0">
                                        {{ leave.number_of_days }}
                                        <template v-if="leave.is_roster == 0">
                                          <span v-if="leave.number_of_days > 1"
                                            >days</span
                                          >
                                          <span v-else>day</span>
                                        </template>
                                        <template v-else>
                                          <span v-if="leave.number_of_days > 1"
                                            >shifts</span
                                          >
                                          <span v-else>shift</span>
                                        </template>
                                      </template>
                                      <template v-else-if="leave.leave_day == 1"
                                        >First Half</template
                                      >
                                      <template v-else-if="leave.leave_day == 2"
                                        >Second Half</template
                                      >
                                    </td>

                                    <td v-if="roster == 1"
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      <template
                                        v-if="
                                          leave.shifts &&
                                          Object.keys(leave.shifts).length > 0
                                        "
                                      >
                                        <div
                                          v-for="(
                                            shifts_arr, date
                                          ) in leave.shifts"
                                          :key="date"
                                          class="d-inline"
                                        >
                                          <small
                                            v-for="shift in shifts_arr"
                                            :key="
                                              shift.id ||
                                              shift.code ||
                                              shift.name
                                            "
                                            v-b-tooltip.hover
                                            :title="`Date: ${date} - Shift: ${
                                              shift.name
                                            } : ${moment(
                                              shift.start_time,
                                              'hh:mm A'
                                            ).format('hh:mm A')} - ${moment(
                                              shift.end_time,
                                              'hh:mm A'
                                            ).format('hh:mm A')}`"
                                            class="border rounded p-1 mr-1"
                                            :style="`background-color:${
                                              (shift.color || '#000') + '22'
                                            }; color:${shift.color || '#000'};`"
                                          >
                                            {{ shift.code }}
                                          </small>
                                        </div>
                                      </template>
                                      <span v-else>N/A</span>
                                    </td>
                                    <td
                                      class="leave-reason-wrapper w-200"
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      <diV>
                                        {{ leave.reason }} <br />
                                        <div class="text-center">
                                          <b-link
                                            v-if="leave.attachment"
                                            @click="
                                              downloadFileContent(
                                                '/avatar/' +
                                                  leave.company_id +
                                                  '/leaves/' +
                                                  leave.attachment
                                              )
                                            "
                                            ><img
                                              :src="
                                                $api_url +
                                                '/images/download_image.png'
                                              "
                                              class=""
                                            />
                                          </b-link>
                                        </div>
                                      </diV>
                                    </td>

                                    <td
                                      class="text-center status-wrapper"
                                      :class="[
                                        leave.status.toLowerCase(),
                                        {
                                          'text-danger':
                                            excess[
                                              leave.employee_id +
                                                '|' +
                                                leave.leave_type_id
                                            ],
                                        },
                                      ]"
                                    >
                                      <span
                                        class="leave-status"
                                        v-if="leave.status == 'Approved'"
                                        ><i class="fa fa-circle mr-1"></i
                                        >{{ leave.status }}</span
                                      >
                                      <span
                                        class="leave-status"
                                        v-if="leave.status == 'Applied'"
                                        ><i class="fa fa-circle mr-1"></i
                                        >Pending</span
                                      >
                                      <span
                                        class="leave-status"
                                        v-if="leave.status == 'Declined'"
                                        ><i class="fa fa-circle mr-1"></i
                                        >{{ leave.status }}</span
                                      >
                                    </td>

                                    <td
                                      class="text-left"
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      {{ leave.updated_by }}
                                    </td>

                                    <td
                                      class="position-relative text-right"
                                      v-if="ce"
                                      :class="{
                                        'text-danger':
                                          excess[
                                            leave.employee_id +
                                              '|' +
                                              leave.leave_type_id
                                          ],
                                      }"
                                    >
                                      <template
                                        v-if="leave.status == 'Applied'"
                                      >
                                        <a
                                          id="actionDropdown"
                                          class="dropdown-toggle clearfix action-dropdown-toggle"
                                          href="#"
                                          role="button"
                                          data-toggle="dropdown"
                                          aria-haspopup="true"
                                          aria-expanded="false"
                                          ><b-icon
                                            icon="three-dots-vertical"
                                          ></b-icon
                                        ></a>
                                        <div
                                          class="dropdown-menu action-dropdown-menu w-200"
                                          aria-labelledby="actionDropdown"
                                        >
                                          <b-button-toolbar class="">
                                            <b-button-group class="mr-0">
                                              <b-button
                                                class="rounded delete-btn"
                                                title="Delete"
                                                @click="
                                                  deleteLeave(
                                                    leave.employee_id,
                                                    leave.leave_type_id,
                                                    leave.flg_status,
                                                    leave.from,
                                                    leave.to
                                                  )
                                                "
                                              >
                                                <b-icon
                                                  icon="trash"
                                                  class="mr-2"
                                                  aria-hidden="true"
                                                ></b-icon
                                                >Delete
                                              </b-button>
                                            </b-button-group>
                                          </b-button-toolbar>
                                        </div>
                                      </template>
                                    </td>
                                  </tr>
                                </template>
                                <template v-else>
                                  <tr class="hover-bg table-row">
                                    <td
                                      class="cursor-pointer trz_relative text-center"
                                      colspan="10"
                                    >
                                      No Result Found!
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>

                          <div
                            class="row py-2 no-margin"
                            v-if="paginatedData.length > 0"
                          >
                            <div
                              class="col-md-12 p-0 no-margin"
                              v-if="paginatedData.length > 0"
                            ></div>
                          </div>
                          <div class="mt-2" v-if="paginatedData.length > 0">
                            <ul
                              class="pagination b-pagination float-left mb-0 mt-1"
                            >
                              <li class="page-item disabled m-2">View</li>
                              <li class="page-item disabled">
                                <b-form-select
                                  v-model="temp_length"
                                  :options="length_options"
                                  @change="setFirstPage()"
                                ></b-form-select>
                              </li>
                              <li class="page-item disabled m-2">
                                per page. Total {{ people }} records found.
                              </li>
                            </ul>
                            <b-pagination-nav
                              class="float-right mt-1"
                              v-model="pagination.currentPage"
                              :number-of-pages="pagination.pages"
                              prev-text="Previous"
                              next-text="Next"
                              base-url="#"
                              first-number
                              last-number
                            ></b-pagination-nav>
                            <!-- <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav>
                        -->
                          </div>
                        </b-overlay>
                      </div>
                    </div>

                    <div class="row mt-5">
                      <div class="col-sm-12 employee-table-wrapper">
                        <h5 class="company-form-box-title mb-3 pb-3">
                          Leave Balance
                          <i class="font-weight-normal">(In Days)</i>
                        </h5>
                        <table class="employee-list-table employee-list-table-leave dataTable table-overflow ess-custom-table">
                          <thead>
                            <tr class="table-head">
                              <th>Leave Category</th>
                              <th v-if="encash == 1">Encashed Leaves</th>
                              <th v-if="carry == 1">Carried</th>
                              <th>Allocated Leaves</th>
                              <th>Applied Leaves</th>
                              <th>Leaves Taken</th>
                              <th>Leaves Remaining</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="table-row hover-bg"
                              v-for="leave_type in leave_available"
                              :key="leave_type.id"
                            >
                              <td>
                                <b-icon :icon="leave_type.icon || 'calendar'" class="mr-2 text-primary" font-scale="1.1"></b-icon>
                                {{ leave_type.leave_title }}
                              </td>
                              <td v-if="encash == 1">
                                {{ leave_type.encashed }}
                                <span v-if="is_roster">Shifts</span>
                                <span v-else>Days</span>
                              </td>
                              <td v-if="carry == 1">
                                {{ leave_type.carried }}
                                <span v-if="is_roster">Shifts</span>
                                <span v-else>Days</span>
                              </td>
                              <td>
                                {{ leave_type.allowed }}
                                <span v-if="is_roster">Shifts</span>
                                <span v-else>Days</span>
                                <i
                                  class="text-small"
                                  v-if="leave_type.event > 0"
                                  >({{ leave_type.event }} Lifetime Usage)</i
                                >
                              </td>
                              <td>
                                {{ leave_type.applied }}
                                <span v-if="is_roster">Shifts</span>
                                <span v-else>Days</span>
                              </td>
                              <td>
                                {{ leave_type.enjoyed }}
                                <span v-if="is_roster">Shifts</span>
                                <span v-else>Days</span>
                              </td>
                              <td>
                                {{ leave_type.remaining }}
                                <span v-if="is_roster">Shifts</span>
                                <span v-else>Days</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <b-modal
                      id="bv-modal-add-leave-profile"
                      size="xl"
                      dialog-class="w-1200"
                      scrollable
                      hide-footer
                    >
                      <template #modal-title>
                        <div class="leave-profile wrapper">
                          <div class="leave-profile header">
                            Application for Leave
                          </div>
                        </div>
                      </template>
                      <roster-ess-employee-leave-details
                        :editflg="0"
                        v-on:childToParent="reloadMe"
                      >
                      </roster-ess-employee-leave-details>
                    </b-modal>
                    <!--- search employee and add leave --->
                    <b-modal
                      id="bv-modal-add-leave"
                      size="xl"
                      scrollable
                      hide-footer
                      title="Leave Details"
                    >
                      <search-employee
                        v-if="employee_id == 0"
                        v-on:childToParent="setEmployee"
                      ></search-employee>
                      <employee-leave-details
                        v-if="employee_id > 0"
                        :editflg="0"
                        v-on:childToParent="getLeaves"
                      ></employee-leave-details>
                    </b-modal>
                    <!-- update leave data -->
                    <b-modal
                      id="bv-modal-edit-leave"
                      size="xl"
                      scrollable
                      hide-footer
                      title="Leave Details"
                    >
                      <employee-leave-details
                        v-if="employee_id > 0"
                        :editflg="1"
                        :leave_type_id="this.tmp_leave_type_id"
                        :flg_status="this.tmp_flg_status"
                        :from="this.tmp_from"
                        :to="this.tmp_to"
                        v-on:childToParent="getLeaves"
                      ></employee-leave-details>
                    </b-modal>

                    <b-modal
                      id="bv-modal-import-leave"
                      scrollable
                      hide-footer
                      title="Import Leaves"
                    >
                      <b-overlay :show="showoverlay" rounded="sm" class="">
                        <b-form-file
                          id="datafile"
                          name="datafile"
                          @change="uploadLeaveFile"
                          accept=".xlsx,.xls"
                        ></b-form-file>
                        <div v-if="errormsg">
                          <div
                            v-if="errormsg.length > 0"
                            class="alert alert-danger my-3"
                          >
                            Total error {{ errormsg.length }}
                          </div>
                          <ul class="list-group">
                            <li
                              class="list-group-item list-group-item-danger"
                              v-for="error in errormsg"
                              :key="error"
                            >
                              {{ error }}
                            </li>
                          </ul>
                        </div>
                      </b-overlay>
                    </b-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  mounted() {
    if (this.check_ce == 1) {
      if (this.ce_flg == 1) this.ce = true;
      else this.ce = false;
    }

    if (this.manager) this.ce = false;
  },
  props: ["flg", "manager"],
  components: {},
  data() {
    let sortOrders = {};
    let columns = [
      { label: "Leave Category", name: "leave_type" },
      { label: "From", name: "from" },
      { label: "To", name: "to" },
      { label: "No of Days", name: "number_of_days" },
      { label: "Reason", name: "reason" },
      { label: "Status", name: "status" },
      { label: "Updated By", name: "updated_by" },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    /** Sohel Code Ends Here */

    return {
      years: [],
      carry: 0,
      encash: 0,
      leave_year: new Date().getFullYear(),
      /** Sohel Code Starts Here */
      columns: columns,
      sortKey: "employee_name",
      sortOrders: sortOrders,
      /** Sohel Code Ends Here */

      leaves: [],
      excess: [],

      showoverlay: false,
      showoverlay_list: false,
      movenext: false,

      errormsg: [],
      fdata: {},

      search: "",
      length: 10,
      pagination: { currentPage: 1, pages: 1 },
      temp_length: 10,
      length_options: [],

      ce: true,
      employee_id: 0,

      approved_leaves_today: 0,
      pending_leaves_today: 0,
      pending_leaves_fiscal_year: 0,

      tmp_leave_type_id: 0,
      tmp_flg_status: 0,
      tmp_from: "",
      tmp_to: "",
      leave_available: [],

      start_date: null,
      end_date: null,
      lv: [],
      this_month_holidays: [],
      this_month: 1,
      this_year: 2020,
      weekly_holidays: [6],
      first_day_of_week: 7,
      total_working_day: 0,
      total_weekends: 0,
      total_holidays: 0,
      roster: 0,

      masks: {
        title: "MMMM YYYY",
        weekdays: "WW",
        navMonths: "MMM",
        input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
        dayPopover: "WWW, MMM D, YYYY",
        data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"],
      },

      attributes: [
        {
          key: "today",
          dot: "pink",
          dates: new Date(),
        },
      ],
      people: 0,
    };
  },
  methods: {
    moment,
    reloadMe() {
      this.$bvModal.hide("bv-modal-add-leave-profile");
      this.getLeaves();
      this.getApprovePendingLeavesToday();
    },
    getLeaveYears() {
      axios
        .get(this.$api_url + "/front/leave-attendance/leave-years/list")
        .then((response) => {
          this.years = response.data;
        });
    },
    monthDetails: function (x) {
      let currentObj = this;
      let year = x["year"];
      let month = x["month"];
      let st_date = new Date(year, month - 1, 1);
      let en_date = new Date(year, month, 0);

      this.this_month = x["month"];
      this.this_year = x["year"];

      this.start_date = moment(String(st_date)).format("Do MMMM YYYY");
      this.end_date = moment(String(en_date)).format("Do MMMM YYYY");

      // fetch holidays dynamically from controller
      axios
        .get(this.$api_url + "/front/leave-attendance/holidays/details", {
          params: {
            st_date: this.start_date,
            en_date: this.end_date,
          },
        })
        .then(
          function (response) {
            this.weekly_holidays = response.data.report.week_holidays
              .split(",")
              .map(function (item) {
                return parseInt(item, 10) + 1;
              });
            this.first_day_of_week =
              parseInt(response.data.report.week_start_day) + 1;

            this.this_month_holidays = response.data.holidays;

            this.total_working_day = response.data.report.total_working_day;
            this.total_weekends = response.data.report.weekends;
            this.total_holidays = response.data.report.holidays;
          }.bind(this)
        )
        .catch(function (error) {
          currentObj.serverError(error);
        });
    },
    importLeaves: function () {
      this.$bvModal.show("bv-modal-import-leave");
    },
    uploadLeaveFile: function (event) {
      if (!this.checkNet()) return false;
      this.showoverlay = true;
      this.errormsg = [];
      // this function upload the logo
      this.empfile = event.target.files[0];

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      const data = new FormData();
      data.append("empfile", this.empfile);

      axios
        .post(
          this.$api_url +
            "/front/leave-attendance/employee/leave/import/import",
          data,
          config
        )
        .then(
          function (response) {
            this.$bvToast.toast("Processing the data feed file.", {
              title: `Job on progress`,
              variant: "info",
              solid: true,
            });

            this.$bvModal.hide("bv-modal-import-leave");

            this.getLeaves();
          }.bind(this)
        )
        .catch(function (error) {
          //alert(error.response.data.errors);
        });
    },
    getLeaves: function () {
      if (!this.checkNet()) return false;

      if (this.flg == 0) this.employee_id = 0;

      this.$bvModal.hide("bv-modal-leave-details");
      let currentObj = this;
      axios
        .get(
          this.$api_url +
            "/front/leave-attendance/employee/leaves/year?flg=" +
            this.flg,
          {
            params: {
              year: this.leave_year,
            },
          }
        )
        .then(
          function (response) {
            this.leaves = response.data.leaves;
            this.excess = response.data.excess;
            this.leave_available = response.data.available || [];
            this.employee_id = response.data.employee_id;

            this.$bvModal.hide("bv-modal-edit-leave");
            this.$bvModal.hide("bv-modal-add-leave");
            this.showoverlay = true;
            axios
              .get(this.$api_url + "/front/leave-attendance/employee/leaves")
              .then((response) => {
                if (response.data.length != 0) {
                  this.leave_available = response.data.available;
                } else {
                  this.has_contract = false;
                }

                this.showoverlay = false;
              })
              .catch((error) => {
                this.showoverlay = false;
                this.serverError(error);
              });
          }.bind(this)
        )
        .catch(function (error) {
          currentObj.serverError(error);
        });
    },

    getApprovePendingLeavesToday: function () {
      if (!this.checkNet()) return false;

      let currentObj = this;
      axios
        .get(
          this.$api_url +
            "/front/leave-attendance/approve-pending/leaves/today",
          {
            params: {
              //employee_id: this.employeeId
            },
          }
        )
        .then(
          function (response) {
            this.approved_leaves_today = response.data.approved_leaves_today;
            this.pending_leaves_today = response.data.pending_leaves_today;
            this.pending_leaves_fiscal_year =
              response.data.pending_leaves_fiscal_year;
          }.bind(this)
        )
        .catch(function (error) {
          currentObj.serverError(error);
        });
    },
    setEmployee: function (x) {
      this.employee_id = x;
    },
    addNew() {
      if (this.flg == 0) this.employee_id = 0;

      this.$bvModal.show("bv-modal-add-leave");
    },
    deleteLeave: function (employee_id, leave_type_id, flg_status, from, to) {
      let formData = new FormData();
      formData.append("employee_id", employee_id);
      formData.append("leave_type_id", leave_type_id);
      formData.append("from", from);
      formData.append("to", to);
      formData.append("flg_status", flg_status);

      axios
        .post(
          this.$api_url + "/front/leave-attendance/leave/delete/range",
          formData
        )
        .then(
          function (response) {
            this.$bvToast.toast("Deleted!", {
              title: `Success`,
              variant: "success",
              solid: true,
            });

            this.getLeaves();
            this.getApprovePendingLeavesToday();
          }.bind(this)
        )
        .catch(function (error) {
          currentObj.showoverlay = false;
          currentObj.serverError(error);
        });
    },

    onSubmit(e) {
      if (!this.checkNet()) return false;
      this.warningmsg = null;
      this.successmsg = null;

      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        this.showoverlay = true;

        e.preventDefault();
        let currentObj = this;
        const config = {};

        let formData = new FormData();

        for (let [key, value] of Object.entries(this.fdata)) {
          var nm = `${key}`;
          var fval = `${value}`;
          formData.append(nm, fval);
          //console.log(`${key}: ${value}`);
        }

        axios
          .post(this.$api_url + "/front/signatory/save", formData, config)
          .then(
            function (response) {
              //console.log(response.data);
              this.leaves = response.data;

              this.$bvToast.toast("Saved!", {
                title: `Success`,
                variant: "success",
                solid: true,
              });

              this.showoverlay_list = false;
              this.showoverlay = false;
              this.resetForm();
              //this.movenext = true;

              this.$bvModal.hide("bv-modal-signatory");
            }.bind(this)
          )
          .catch(function (error) {
            this.showoverlay_list = false;
            this.showoverlay = false;

            currentObj.serverError(error);
            currentObj.errormsg = error.response.data.errors;
          });
      });
    },
    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/front/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.roster = response.data.roster;
          this.carry = response.data.carry;
          this.encash = response.data.encash;
          if(this.roster == 1) {
            this.columns = [
              { label: "Leave Category", name: "leave_type" },
              { label: "From", name: "from" },
              { label: "To", name: "to" },
              { label: "No of Shifts/Days", name: "number_of_days" },
              { label: "Shifts", name: "shift" },
              { label: "Reason", name: "reason" },
              { label: "Status", name: "status" },
              { label: "Updated By", name: "updated_by" },
            ];
          }
        }
      }.bind(this));
    },
  },
  created: function () {
    this.getLeaves();
    this.getLeaveYears();
    this.getApprovePendingLeavesToday();
    this.getCompanyLeaveSettings();
    Fire.$on("reloadUsers", () => {
      this.getLeaves();
    });
  },
  computed: {
    filteredData() {
      let filtered_list = this.leaves;
      this.people = this.leaves.length;
      this.length_options = [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 200, text: "200" },
        { value: 500, text: "500" },
        { value: this.leaves.length, text: "All" },
      ];
      if (this.search) {
        filtered_list = filtered_list.filter((row) => {
          return Object.keys(row).some((key) => {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1
            );
          });
        });

        if (filtered_list.length == 0) this.blankmsg = "Nothing found.";
      }

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        filtered_list = filtered_list.slice().sort((a, b) => {
          let index = this.getIndex(this.columns, "name", sortKey);
          a = String(a[sortKey]).toLowerCase();
          b = String(b[sortKey]).toLowerCase();
          if (this.columns[index] != undefined) {
            if (
              this.columns[index].type &&
              this.columns[index].type === "date"
            ) {
              return (
                (a === b
                  ? 0
                  : new Date(a).getTime() > new Date(b).getTime()
                  ? 1
                  : -1) * order
              );
            } else if (
              this.columns[index].type &&
              this.columns[index].type === "number"
            ) {
              return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
            } else {
              return (a === b ? 0 : a > b ? 1 : -1) * order;
            }
          }
        });
      }

      return filtered_list;
    },
    paginatedData() {
      return this.paginate(
        this.filteredData,
        this.length,
        this.pagination.currentPage
      );
    },
  },
};
</script>
